<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="6">
					<plant-select />
				</el-col>
				<el-col :span="6">
					<search-input :label="getMessage_('SWCC000337')" paramKey="msgKey" ref="searchMsgKey" />
				</el-col>
				<el-col :span="6">
					<search-input :label="getMessage_('SWCC000338')" paramKey="msgText" ref="searchMsgText" />
				</el-col>
				<el-col :span="6">
					<msgLoc-select ref="searchMsgLoc" @reload="searchList()" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootMethods, rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
import PlantSelect from './PlantSelect.vue';
import MsgLocSelect from './MsgLocSelect.vue';
import SearchInput from './SearchInput.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect, MsgLocSelect, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 10) {
			this.$sf_toggleLoading(true);
			this.getDicMsgManagements_({ currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		reset() {
			this.$refs.searchMsgKey.data = null;
			this.$refs.searchMsgText.data = null;
			this.$refs.searchMsgLoc.data = null;
		}
	},
	created() {
		this.searchList();
		this.getCommCodes_({ key: 'langs', codeType: 'LANG' }).catch(error => {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			Promise.reject(error);
		});
		this.getCommCodes_({ key: 'msgTypes', codeType: 'MSG_TYPE' })
			.then(() => {
				this.msgTypes.forEach(row => {
					this.gridMsgTypes.push({
						label: row.commCdName,
						value: row.commCd
					});
				});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
	}
};
</script>

<style>
.button-pre {
	white-space: pre;
}
</style>
